import {useRouter} from 'next/router';

import ArrowIcon from '@/public/images/arrow-right-gradient.svg';
import css from '@/src/howTo/styles/BackToList.module.css';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Text} from '@/src/ui';

const BackToList = () => {
  const {back} = useRouter();

  return (
    <div className={css.backButton} onClick={back}>
      <ArrowIcon />
      <Text
        color={Text.COLOR.GRADIENT}
        fontWeight={Text.FONT_WEIGHT.BOLD}
        fontSize={Text.FONT_SIZE.SIZE_16}
      >
        <TextLocal id="wiki-how.back-to-list" />
      </Text>
    </div>
  );
};

export default BackToList;
